import React, { useState } from "react";
import webDesign from "../../assets/web-design.png";
import coding from "../../assets/coding.png";
import applcation from "../../assets/application.png";
import business from "../../assets/business.png";
import { v4 as uuidv4 } from "uuid";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Button } from "@mui/material";

const Features = () => {
  let featureList = [
    {
      id: uuidv4(),
      title: "Static Web Apps",
      image: webDesign,
      description:
        "Crafting visually captivating and user-centric websites, our web design services blend creativity with functionality, delivering an immersive digital experience that resonates with your audience.",
    },
    {
      id: uuidv4(),
      title: "Dynamic Web Apps",
      image: coding,
      description:
        "Our web development expertise transforms innovative ideas into robust, interactive websites. With a focus on cutting-edge technology and seamless functionality, we bring your vision to life.",
    },
    {
      id: uuidv4(),
      title: "E-Commerce Web Apps",
      image: applcation,
      description:
        "Building powerful web applications tailored to your unique needs, we create dynamic solutions that streamline processes, boost productivity, and offer an engaging user experience.",
    },
    {
      id: uuidv4(),
      title: "Business Web Apps",
      image: business,
      description:
        "Efficiency Redefined: Transform your operations with our business web apps, tailored to enhance productivity, streamline processes, and drive success in the digital realm..",
    },
  ];
  return (
    <div id="solutions">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Features we Provide
      </p>
      <div className="flex sm:grid sm:grid-cols-2 sm:justify-items-center px-3 sm:px-20 mt-10 gap-3 flex-col sm:flex-row">
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInLeft">
          <div className="w-full h-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md">
            <div className="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              Website Design & Development
            </div>
            <div className="col-span-2 rounded-md">
              <p className="text-gray-700 text-base font-notosans">
                Unlock the potential of your online presence with our dynamic
                <b>Website Design and Development</b> services. Our expert team
                specializes in creating visually stunning and user-friendly
                websites that stand out in the digital landscape. Whether you're
                looking for a brand-new <b>website design</b> or a{" "}
                <b>redesign</b> to refresh your online presence, we've got the
                expertise to bring your vision to life. With a focus on{" "}
                <b>UI/UX design</b> , we ensure that your website not only looks
                great but also provides an intuitive and seamless browsing
                experience for your visitors. Elevate your brand with our
                comprehensive <b>website design and development</b>
                solutions tailored to your unique needs.
              </p>
            </div>
            <div>
              <Button variant="outlined" href="#contact">
                Let's Connect
              </Button>
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInRight">
          <div className="w-full h-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md">
            <div className="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              Custom Software Solutions
            </div>
            <div className="col-span-2 rounded-md">
              <p className="text-gray-700 text-base font-notosans">
                Transform your business with our bespoke{" "}
                <b>Custom Software Solutions</b> tailored to your needs. From
                intuitive <b>Content Management Software</b> to efficient{" "}
                <b>ERP</b> and <b>CRM</b> systems, we specialize in developing
                customized solutions that streamline your operations and drive
                growth. Our team of experts works closely with you to understand
                your unique requirements and deliver software that enhances
                productivity and efficiency across your organization. Experience
                the power of tailored software solutions designed to propel your
                business forward.
              </p>
            </div>
            <div>
              <Button variant="outlined" href="#contact">
                Let's Connect
              </Button>
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInLeft">
          <div className="w-full h-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md">
            <div className="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              E-Commerce Websites
            </div>
            <div className="col-span-2 rounded-md">
              <p className="text-gray-700 text-base font-notosans">
                Elevate your <b>E-Commerce business</b> with our expertly
                crafted
                <b>E-Commerce websites</b> . We specialize in creating seamless{" "}
                <b>online shopping</b> experiences that drive sales and customer
                satisfaction. From user-friendly interfaces to secure{" "}
                <b>online payments</b> , our
                <b>eCommerce</b> websites are designed to maximize your online
                presence and streamline transactions. Trust us to deliver
                cutting-edge eCommerce solutions tailored to your business
                needs. Experience the power of e-commerce with our bespoke
                website designs.
              </p>
            </div>
            <div>
              <Button variant="outlined" href="#contact">
                Let's Connect
              </Button>
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInRight">
          <div className="w-full h-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md">
            <div className="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              App Development
            </div>
            <div className="col-span-2 rounded-md">
              <p className="text-gray-700 text-base font-notosans">
                Empower your business with our premium{" "}
                <b>App Development Service</b>. With expertise in{" "}
                <b>mobile app development</b> for <b>Android</b> and <b>iOS</b>
                platforms, we specialize in creating customized solutions that
                cater to your unique requirements. we create innovative and
                user-friendly applications tailored to your specific needs. Our
                expert team combines <b>cutting-edge technology</b> with
                intuitive design to deliver <b>high-quality apps</b> that engage
                users and drive results. Whether you're looking to expand your
                reach or enhance customer experience, trust us to bring your app
                development ideas to life. Elevate your business with our
                custom-built
                <b>Android and iOS apps</b>.
              </p>
            </div>
            <div>
              <Button variant="outlined" href="#contact">
                Let's Connect
              </Button>
            </div>
          </div>
        </AnimationOnScroll>
        {/* ))} */}
      </div>
    </div>
  );
};

export default Features;
